import { useEffect, useContext } from "react";
import AuthForm from "../components/Auth/AuthForm";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../store/auth-slice";
import { useLocation, useNavigate } from "react-router-dom";
import { loginWithOTC } from "../api";
import UserContext from "../contexts/UserContext";

export default function AuthPage(props) {
  const userContext = useContext(UserContext);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((store) => store.auth);

  useEffect(() => {
    (async () => {
      const searchParams = new URLSearchParams(location.search);
      const userId = searchParams.get("userId");
      const otc = searchParams.get("otc");
      if (userId && otc && userContext.user?.userId !== userId) {
        const result = await loginWithOTC({ userId, otc });
        userContext.setUser({ ...result });
        navigate("/events");
      } else {
        if (isAuthenticated) {
          dispatch(authActions.closeForm());
        } else {
          dispatch(authActions.openForm());
        }
      }
    })();
  }, [location.search, userContext, navigate, isAuthenticated, dispatch]);

  return <AuthForm title={props.title} />;
}
